import { useNosIdQuery } from '@/hooks/api/base.hooks';
import { api } from '@/portal-api.definition';
import { queryOptions } from '@tanstack/react-query';

const AvatarsQueryOptions = (type: 'Preset' | 'Kids' | 'Woo') =>
  queryOptions({
    queryKey: ['avatars', type],
    queryFn: () => api.get('/api/v1/profiles/avatars', { search: { type } }),
  });

export function useGetAvatars(type: 'Preset' | 'Kids' | 'Woo') {
  return useNosIdQuery(AvatarsQueryOptions(type));
}
